import { createActionConst } from '../../../utils/action.utils';

const PROJECT_REPORT_NAMESPACE = 'PROJECT_REPORT';

export const STORE_PROJECT_REPORT = createActionConst(PROJECT_REPORT_NAMESPACE, 'STORE_PROJECT_REPORT');
export const CLEAR_PROJECT_REPORT = createActionConst(PROJECT_REPORT_NAMESPACE, 'CLEAR_PROJECT_REPORT');
